export default "__VITE_ASSET__B1738ocJ__"